import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { dismissSuccessToast } from "../../../store/slices/successToastSlice"
import SuccessToast, { RichPlanToastMessage } from "./SuccessToast"

const TOAST_AUTO_DISMISS_MS = 4000
const TOAST_EXTENDED_DISMISS_MS = 8000

export default function SuccessToastHost() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const visible = useSelector((state) => state.successToast?.visible)
  const message = useSelector((state) => state.successToast?.message)
  const subtext = useSelector((state) => state.successToast?.subtext)
  const actionLabel = useSelector((state) => state.successToast?.actionLabel)
  const actionPath = useSelector((state) => state.successToast?.actionPath)
  const richPlan = useSelector((state) => state.successToast?.richPlan)

  const hasAction = Boolean(actionLabel && actionPath)
  const hasContent = Boolean(message) || Boolean(richPlan)
  const dismissMs = hasAction || subtext || richPlan ? TOAST_EXTENDED_DISMISS_MS : TOAST_AUTO_DISMISS_MS

  useEffect(() => {
    if (!visible) return
    const t = setTimeout(() => dispatch(dismissSuccessToast()), dismissMs)
    return () => clearTimeout(t)
  }, [visible, message, subtext, actionLabel, actionPath, richPlan, dismissMs, dispatch])

  if (!visible || !hasContent) return null

  const handleAction = () => {
    dispatch(dismissSuccessToast())
    navigate(actionPath)
  }

  return (
    <div className="success-toast-host">
      <SuccessToast
        message={message}
        subtext={subtext}
        actionLabel={hasAction ? actionLabel : undefined}
        onAction={hasAction ? handleAction : undefined}
        onDismiss={() => dispatch(dismissSuccessToast())}
      >
        {richPlan ? (
          <RichPlanToastMessage
            kind={richPlan.kind}
            count={richPlan.count}
            dateLabel={richPlan.dateLabel}
          />
        ) : undefined}
      </SuccessToast>
    </div>
  )
}
